module.exports = __webpack_public_path__ + "media/metronic/_theme/media/project-logos/6-76264728e5a938abb922e9bc2c63957f.png";